import React from 'react';
import { AGENCIES_PAGE_SIZE } from '../../../../utils/constants/agencies';
import {
  SkeletonBody,
  SkeletonCard,
  SkeletonDescription,
  SkeletonDescriptionLine,
  SkeletonInfo,
  SkeletonLogo,
  SkeletonOffersCount,
  SkeletonPhone,
  SkeletonRow,
  SkeletonTitle
} from './styled';

export const AgencyCardSkeleton: React.FC = () => (
  <SkeletonCard data-cy="agency-skeleton">
    <SkeletonRow>
      <SkeletonLogo />
      <SkeletonInfo>
        <SkeletonTitle />
        <SkeletonOffersCount />
      </SkeletonInfo>
    </SkeletonRow>
    <SkeletonBody>
      <SkeletonDescription />
      <SkeletonDescriptionLine />
    </SkeletonBody>
    <SkeletonPhone />
  </SkeletonCard>
);

interface AgencyCardsSkeletonProps {
  count?: number;
}

export const agencyCardsSkeletonCards = (count: number) =>
  Array.from({ length: count }, (_, index) => (
    <AgencyCardSkeleton key={index} />
  ));

export const AgencyCardsSkeleton: React.FC<AgencyCardsSkeletonProps> = ({
  count = AGENCIES_PAGE_SIZE
}) => <>{agencyCardsSkeletonCards(count)}</>;
